import axios from 'axios';
import { MessageBox } from 'element-ui'  //可以不用，此处是使用elementUI 的弹框
// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        data: params,
        traditional: true
    }).then(res => res.data);
};
// 通用公用方法
const loginInfo = (method, url, params) => {
    return axios.get(url, {
        params: params
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    if(method == 'get'){
      return axios.get(url, {
        params: params
      }).then(res => res.data);
    }

    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
        },
        data: params,
        traditional: true,
    }).then(res => res.data);
};

// request 拦截器
//挂载请求拦截器 (相当于请求的预验证，请求到达服务器之前先验证这次请求)
axios.interceptors.request.use(config => {
    //为请求头添加对象，添加token验证的Authorization字段
    config.headers.Authorization = localStorage.getItem('logintoken');
    return config;
});
// response 拦截器
axios.interceptors.response.use(
    function(response){
        const code = response.status;
        const res = response.data;
        if (code == 504) {
            MessageBox.confirm("网络请求超时", "提示", {
                showCancelButton: false,
                type: "warning",
                center:true,
            });
            return Promise.reject(error);
        } else if (code == 500) {
            MessageBox.confirm("找不到请求", "提示", {
                showCancelButton: false,
                type: "warning",
                center:true,
            });
            return Promise.reject(error);
        } else if (code < 200 || code > 300) {
            MessageBox.confirm(response.message, "提示", {
                showCancelButton: false,
                type: "warning",
                center:true,
            });
            return Promise.reject("error");
        } else {
            if (res.resultCode.code == '00104') {
                return response;
            } else if (res.resultCode.code !== '00000') {
                if (res.resultCode.code == '99999') {
                    localStorage.removeItem('logintoken')
                    window.location.href = '/ycb-back/login'
                }
                // 处理自定义错误
                // handleError(res.code);
                MessageBox.confirm(res.resultCode.cnMsg, "提示", {
                    showCancelButton: false,
                    type: "warning",
                    center:true,
                });
                return Promise.reject(new Error(res.resultCode.cnMsg || "响应未知错误"));
            } else {
                // success
                return Promise.resolve(response);
            }
            return response;
        }
    },
    //响应错误拦截
    error => {
        let code = 0;
        try {
            code = error.response.status;
        } catch (e) {
            if (error.toString().indexOf("Error: timeout") !== -1) {
                MessageBox.confirm("网络请求超时", "提示", {
                    showCancelButton: false,
                    type: "warning",
                    center:true,
                });
                return Promise.reject(error);
            }
            if (error.toString().indexOf("Error: Network Error") !== -1) {
                MessageBox.confirm("网络请求错误", "提示", {
                    showCancelButton: false,
                    type: "warning",
                    center:true,
                });
                return Promise.reject(error);
            }
        }
        if (code === 401) {
            MessageBox.confirm("登录状态已过期，请重新登录", "系统提示", {
                confirmButtonText: "重新登录",
                showCancelButton: false,
                showClose: false,
                type: "warning",
                center:true,
            }).then(() => {
                // store.dispatch("LogOut").then(() => {
                //   location.reload(); // 为了重新实例化vue-router对象 避免bug
                // });
            });
        } else if (code === 403) {
            router.push({ path: "/401" });
        } else if (code === 500) {
            MessageBox.confirm('请求未找到', "提示", {
                confirmButtonText: "确定",
                showCancelButton: false,
                showClose: false,
                type: "warning",
                center:true,
            });
        } else {
            const errorMsg = error.response.data.message;
            if (errorMsg !== undefined) {
                MessageBox.confirm(errorMsg, "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    showClose: false,
                    type: "warning",
                    center:true,
                });
            }
        }
        return Promise.reject(error);
    }
);
export {
    loginreq,
    loginInfo,
    req
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js